import { Component } from '@angular/core';

@Component({
  selector: 'app-demokratiewerkstatt-category-detail',
  templateUrl: './demokratiewerkstatt-category-detail.component.html',
  styleUrls: ['./demokratiewerkstatt-category-detail.component.css']
})
export class DemokratiewerkstattCategoryDetailComponent {

}
